import React from 'react';
import { makeStyles, Tooltip, useMediaQuery, useTheme, Icons } from '~/lib/bn-material-ui';
import { useSirenEntity } from '~/utility/BinSentry-ui-utility';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      display: 'inline-flex',
      gap: '0.2em',
      [theme.breakpoints.down('md')]: {
        alignItems: 'center',
      },
    },
    warning: {
      display: 'inline-flex',
      alignItems: 'center',
      border: `1px solid ${theme.palette.yellow[30]}`,
      borderRadius: 4,
      backgroundColor: theme.palette.yellow[10],
      color: theme.palette.yellow[30],
      padding: '0.2em 0.7em',
      marginLeft: '0.5em',
      fontWeight: 'bold',
    },
    warningIcon: {
      [theme.breakpoints.up('md')]: {
        color: theme.palette.warning.main,
      },
      paddingBottom: '1px',
    },
  };
});

export default function OrderQuantity({ feedEntity, orderEntity, orderAmountPreference }) {
  const styles = useStyles();
  const { entity: metricsEntity } = useSirenEntity({ href: orderEntity?.getSubEntity('https://api.binsentry.com/rel/order-metrics')?.href });
  if (!feedEntity || !orderEntity) {
    return '-';
  }

  const orderAmount = orderAmountPreference.convert({
    volume: orderEntity?.properties?.quantity,
    bulkDensity: feedEntity?.properties?.bulkDensity,
  });

  return (
    <div className={styles.container}>
      <span>{`${orderAmount} ${orderAmountPreference.unit}`}</span>
      {metricsEntity?.properties.potentialOverfill && <OverfillWarning />}
    </div>
  );
}

function OverfillWarning() {
  const styles = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile
    ? <div className={styles.warning}><Icons.WarningRounded fontSize='small' className={styles.warningIcon}/> Overfill</div>
    : <Tooltip title='Overfill'><Icons.WarningRounded fontSize='small' className={styles.warningIcon}/></Tooltip>;
}
